<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{
                $t("integraciones")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("GStock") }}
            </li>
          </ol>
        </nav>
      </div>
      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :listBusinessesCompany="listBusinessesCompany"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
        :gStock="true"
        @businessesCompanyUpdated="handleBusinessesCompanyUpdated"
      />
      <template v-if="configTpv">
        <vue-tabs
          @tab-change="handleTabChange"
          v-model="tabs"
          class="col-md-12"
        >
          <v-tab title="" :disabled="true"></v-tab>
          <v-tab title="Productos">
            <div class="d-flex align-items-center flex-wrap" style="gap: 15px; margin: 20px;">
              <!-- Selector Categorías -->
              <el-select
                v-model="idCategoria"
                filterable
                @change="getProductos"
                placeholder="Todos"
                size="large"
                style="min-width: 220px;"
                class="select-default"
              >
                <el-option :value="0" label="Todos las Categorías" />
                <el-option
                  v-for="c in listCategorias"
                  :key="c.id"
                  :value="c.id"
                  :label="c.name"
                />
              </el-select>

              <!-- Buscador -->
              <div class="input-group" style="flex-grow: 1; min-width: 250px; max-width: 400px;">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('buscar')"
                  v-model="searchProductosQuery"
                  @keyup.enter.prevent="searchProductos"
                />
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" @click="searchProductos">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-secondary" type="button" @click="removeSearchProduct">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Botones Replicar PLU -->
              <button
                v-if="listTpv.length > 0"
                class="btn btn-secondary"
                type="button"
                @click="confirmarReplicacionProductos"
                style="white-space: nowrap;"
              >
                {{ $t("replicarPLUPRod") }}
              </button>          

              <button
                v-if="listTpv.length > 0"
                class="btn btn-secondary"
                type="button"
                @click="$modal.show('modalSeleccionBusiness')"
                style="white-space: nowrap;"
              >
                {{ $t("replicarPLUsaBusinesses") }}
              </button>
            </div>

            <!-- Tabla Productos -->
            <div class="col-md-12" v-for="(p, indice) in list" :key="indice">
              <h5 class="wrapperNegocio">{{ p.nameCat }}</h5>
              <div class="table-responsive">
                <table class="table table-bordered table-striped text-nowrap">
                  <thead class="thead-dark">
                    <tr style="cursor: pointer">
                      <th>{{ $t("nombre") }}</th>
                      <th>{{ $t("precio") }}</th>
                      <th>PLU</th>
                      <th>{{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(obj, index) in p.listProducts" :key="index">
                      <td v-if="obj.nameprice.trim() !== ''">
                        {{ obj.name.trim() + " [" + obj.nameprice.trim() + "]" }}
                      </td>
                      <td v-else>{{ obj.name.trim() }}</td>
                      <td>{{ obj.price | currency }}</td>
                      <td width="20%">
                        <input class="form-control" type="text" v-model="obj.newPLU" />
                      </td>
                      <td align="center">
                        <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                        <button
                          v-else
                          class="btn btn-warning"
                          @click="changedPLU(obj, 0)"
                        >
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Paginación -->
            <div class="row" v-if="totalPags > 1">
              <div class="col-md-12">
                <nav>
                  <ul class="pagination flex-wrap">
                    <li class="page-item" :class="{ gstock: pag == 1 }">
                      <router-link
                        class="page-link"
                        :to="{ name: 'gstock', params: { pag: pag - 1 } }"
                        v-if="pag != 1"
                      >
                        &laquo;
                      </router-link>
                      <span v-else class="page-link">
                        <span aria-hidden="true">&laquo;</span>
                      </span>
                    </li>
                    <li
                      class="page-item"
                      v-for="n in totalPags"
                      :key="n"
                      :class="{ active: n == pag }"
                    >
                      <router-link
                        class="page-link"
                        :to="{ name: 'gstock', params: { pag: n } }"
                      >
                        {{ n }}
                      </router-link>
                    </li>
                    <li class="page-item" :class="{ disabled: pag == totalPags }">
                      <router-link
                        class="page-link"
                        :to="{ name: 'gstock', params: { pag: nextPag } }"
                        v-if="pag != totalPags"
                      >
                        &raquo;
                      </router-link>
                      <span v-else class="page-link">
                        <span aria-hidden="true">&raquo;</span>
                      </span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </v-tab>

         <v-tab title="Materias Primas">
          <div class="d-flex align-items-center flex-wrap" style="gap: 15px; margin: 20px;">
            <!-- Selector Categorías -->
            <el-select
              v-model="idTag"
              filterable
              @change="getSubproducts()"
              placeholder="Todos"
              size="large"
              style="min-width: 220px;"
              class="select-default"
            >
              <el-option :value="0" label="Todos las Categorías" />
              <el-option
                v-for="c in listTags"
                :key="c.id"
                :value="c.id"
                :label="c.name"
              />
            </el-select>

            <!-- Buscador -->
            <div class="input-group" style="flex-grow: 1; min-width: 250px; max-width: 400px;">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('buscar')"
                v-model="searchQuery"
                @keyup.enter.prevent="searchSubproductos"
              />
              <div class="input-group-append">
                <button class="btn btn-secondary" type="button" @click="searchSubproductos">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-secondary" type="button" @click="removeSearchSubPRoduct">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <!-- Botones Replicar PLU -->
            <button
              v-if="listTpv.length > 0"
              class="btn btn-secondary"
              type="button"
              @click="confirmarReplicacionSubproductos()"
              style="white-space: nowrap;"
            >
              {{ $t("replicarPLUSubPRod") }}
            </button>    

            <button
              v-if="listTpv.length > 0"
              class="btn btn-secondary"
              type="button"
              @click="$modal.show('modalSeleccionBusinessSubproducts')"
              style="white-space: nowrap;"
            >
              {{ $t("replicarPLUaBusinesses") }}
            </button>
          </div>

          <!-- Aquí continúa el contenido con la tabla -->
          <div class="col-md-12" v-for="(p, indice) in listSubproducts" :key="indice">
            <h5 class="wrapperNegocio">{{ p.nameTag }}</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr style="cursor: pointer">
                    <th>{{ $t("nombre") }}</th>
                    <th>PLU</th>
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(obj, index) in p.listSubProducts" :key="index">
                    <td>{{ obj.name.trim() }}</td>
                    <td width="20%">
                      <input class="form-control" type="text" v-model="obj.newPLU" />
                    </td>
                    <td align="center">
                      <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                        <i class="fa-solid fa-floppy-disk"></i>
                      </button>
                      <button
                        v-else
                        class="btn btn-warning"
                        @click="changedPLU(obj, 1)"
                      >
                        <i class="fa-solid fa-floppy-disk"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row" v-if="totalPags > 1">
            <div class="col-md-12">
              <nav>
                <ul class="pagination flex-wrap">
                  <li class="page-item" :class="{ gstock: pag == 1 }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'gstock', params: { pag: pag - 1 } }"
                      v-if="pag != 1"
                    >
                      &laquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&laquo;</span></span
                    >
                  </li>
                  <li
                    class="page-item"
                    v-for="n in totalPags"
                    :key="n"
                    :class="{ active: n == pag }"
                  >
                    <router-link
                      class="page-link"
                      :to="{ name: 'gstock', params: { pag: n } }"
                    >
                      {{ n }}
                    </router-link>
                  </li>
                  <li class="page-item" :class="{ disabled: pag == totalPags }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'gstock', params: { pag: nextPag } }"
                      v-if="pag != totalPags"
                    >
                      &raquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&raquo;</span></span
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </v-tab>
        </vue-tabs>
      </template>
      <template v-else>
        <div class="col-md-12">
          <div class="alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
    </div>

    <modal name="modalSeleccionBusiness" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
    <div>
      <div class="modal-header">
        <h4 style="margin: 0px">{{ $t("replicarPLUsaBusinesses") }}</h4>
      </div>

      <div class="modal-body">
        <!-- Checkbox seleccionar todos -->
        <el-checkbox
          v-model="selectAllProducts"
          @change="toggleSelectAllProducts"
          style="margin-bottom: 12px;"
        >
          {{ $t("seleccionarTodos") }}
        </el-checkbox>

        <!-- Lista de negocios -->
        <div v-for="business in listBusinessesCompany" :key="business.id">
          <el-checkbox
            v-model="selectedBusinessCompany"
            :label="business.id"
            border
            class="checkbox-element"
            style="width: 100%; margin-bottom: 6px;"
            @change="checkIfAllSelectedProducts"
          >
            {{ business.establishmentName }}
          </el-checkbox>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default" @click="closeModal()">
          <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
        </button>

        <button
          class="btn btn-primary"
          :disabled="selectedBusinessCompany.length === 0"
          @click="confirmarReplicacionProductosPLUBusiness"
        >
          <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
        </button>
      </div>
    </div>
  </modal>

    <modal
    name="modalSeleccionBusinessSubproducts"
    :adaptive="true"
    :scrollable="true"
    height="auto"
    :clickToClose="false"
  >
    <div>
      <div class="modal-header">
        <h4 style="margin: 0px">{{ $t("replicarPLUaBusinesses") }}</h4>
      </div>

      <div class="modal-body">
        <!-- Checkbox seleccionar todos -->
        <el-checkbox
          v-model="selectAll"
          @change="toggleSelectAllSubproducts"
          style="margin-bottom: 12px;"
        >
          {{ $t("seleccionarTodos") }}
        </el-checkbox>

        <!-- Lista de negocios -->
        <div v-for="business in listBusinessesCompany" :key="business.id">
          <el-checkbox
            v-model="selectedBusinessCompanySubproducts"
            :label="business.id"
            border
            class="checkbox-element"
            style="width: 100%; margin-bottom: 6px;"
            @change="checkIfAllSelected"
          >
            {{ business.establishmentName }}
          </el-checkbox>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default" @click="closeModalSubproducts()">
          <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
        </button>

        <button
          class="btn btn-primary"
          :disabled="selectedBusinessCompanySubproducts.length === 0"
          @click="confirmarReplicacionSubProductosPLUBusiness"
        >
          <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
        </button>
      </div>
    </div>
  </modal>




  </div>

  
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
  Checkbox,
} from "element-ui";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("GStock"));
    this.tabs = "Productos";
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }

    this.loading.close();
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    CabeceraInformes,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      list: [],
      mode: 0,
      objectChart: null,
      contador: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenacionOperario: 0,
      ordenarImporte: 0,
      ordenarInvitations: 0,
      ordenarDifHora: 0,
      ordenarSueldo: 0,
      ordenarEfectivo: 0,
      ordenarTarjeta: 0,
      ordenarCheque: 0,
      ordenarIssues: 0,
      idTpvAMandar: " ",
      configTpv: false,
      respuesta: true,
      indice: 0,
      totalPags: 0,
      pag: this.$route.params.pag,
      cambiar: 0,
      objindex: -1,
      idCategoria: 0,
      listCategorias: [],
      idTag: 0,
      listSubproducts: [],
      tabs: "",
      listTags: [],
      searchQuery: "",
      searchQuery2: "",
      config98: false,
      config99: false,
      config101: false,
      loadingGeneral: null,
      searchProductosQuery: "",
      selectedBusinessCompany: [], // Changed from null to []
      listBusinessesCompany: [],
      idsTPV: [],
      selectAll: false,
      selectedBusinessCompanySubproducts: [], // negocios para subproductos
      selectAllSubproducts: false,
      selectAllProducts: false,
    };
  },
  computed: {
    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
    nextPagSub() {
      let nextPag = parseInt(this.pagSub) + 1;
      return nextPag;
    },

    filteredBusinesses() {
      if (!this.searchBusinessQuery) return this.listBusinessesCompany;
      return this.listBusinessesCompany.filter((business) =>
        business.establishmentName
          .toLowerCase()
          .includes(this.searchBusinessQuery.toLowerCase())
      );
    },

      isAllSelected() {
        return (
          this.selectedBusinessCompany.length === this.listBusinessesCompany.length &&
          this.listBusinessesCompany.length > 0 &&
          this.listBusinessesCompany.every(b =>
            this.selectedBusinessCompany.includes(b.id)
          )
        );
      },

       isAllSubproductsSelected() {
          return (
            this.selectedBusinessCompanySubproducts.length === this.listBusinessesCompany.length &&
            this.listBusinessesCompany.length > 0 &&
            this.listBusinessesCompany.every(b =>
              this.selectedBusinessCompanySubproducts.includes(b.id)
            )
          );
        },
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        if (this.tabs == "Productos") {
          this.getProductos();
        } else if (this.tabs == "Materias Primas") {
          this.getSubproducts();
        }
      } else if (to.params.query) {
        this.query = to.params.query;
        if (this.tabs == "Productos") {
          this.getProductos();
        } else if (this.tabs == "Materias Primas") {
          this.getSubproducts();
        }
      }
    },
    listBusinessesCompany: {
      handler(newVal) {
        console.log("Prop listBusinessesCompany actualizada:", newVal);
        this.selectAllProducts = this.selectedBusinessCompany.length === newVal.length;
        this.selectAllSubproducts = this.selectedBusinessCompanySubproducts.length === newVal.length;
      },
      deep: true,
    },
    selectedBusinessCompanySubproducts(newVal) {
      this.selectAllSubproducts = newVal.length === this.listBusinessesCompany.length;
    },
    selectedBusinessCompany(newVal) {
      this.selectAllProducts = newVal.length === this.listBusinessesCompany.length;
    },
  },
  methods: {
    cambioBusiness(idBusinessData, listTpv) {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.pag = 1;
      this.totalPags = 0;

      this.cambioTpv(this.idTpv);
      this.getConfigGStock();
      // this.getConfigTpv(98);

      if (this.tabs == "Materias Primas") {
        this.getSubproducts();
      } else if (this.tabs == "Productos") {
        //this.handleTabChange();
        this.getProductos();
      }

      this.loadingGeneral.close();
    },

    emitirConsulta() {
      //this.loading = Loading.service({ text: "Cargando..." });
      //this.getSalesOperarios();
      //this.exportGStock();

      this.ConfirmacionExport();
    },

    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }

      this.idTpv = idTpvData;

      //this.emitirConsulta();
    },

    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.getConfigTpv(98);

          vm.getTpv();

          vm.getProductos();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            // vm.exportGStock();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigGStock() {
      let vm = this;

      let configIdentificador = 98;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador,
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.configTpv = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    exportGStock() {
      this.loading = Loading.service({ text: "Cargando..." });
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: 0,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          var params = {
            idBusiness: this.idBusiness,
            idTpv: 0,
            datefrom: moment(this.datefrom).startOf("day").unix(),
            dateto: moment(this.dateto).endOf("day").unix(),
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .post(
              this.$store.getters.apiUrl + "integracion/gstock/exportarGStock",
              params,
              config
            )
            .then(function (response) {
              vm.loading.close();
              
              // Rango excedido
              if (response.data.error_code === "RANGE_EXCEEDED") {
                swal({
                  title: vm.$t("ups"),
                  text: vm.$t("rangoSolicitadoMayorAlPermitido"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              // Acceso denegado
              else if (response.data.error_code === "ACCESS_DENIED") {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: vm.$t("noTienesPermisosParaRealizar"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              // Exportacion completa
              else if (response.data.response === true && response.data.result && response.data.result.success === true) {
                swal({
                  title: vm.$t("ventasExportadasExsitosamente"),
                  text: response.data.result.message || "",
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "success",
                });
                vm.respuesta = true;
              } 
              // Error de exportacion:
              else if (response.data.response === false || (response.data.result && response.data.result.success === false)) {
                const errorMessage = response.data.result && response.data.result.message 
                  ? response.data.result.message 
                  : vm.$t("error");
                
                swal({
                  title: vm.$t("ups"),
                  text: errorMessage,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              } 
              // Default
              else {
                swal({
                  title: vm.$t("atencion"),
                  text: vm.$t("respuestaInvalida"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
            })
            .catch(function (error) {
              vm.loading.close();

              if (error.response) {
                // El servidor respondió con un código de estado fuera del rango de 2xx
                console.log("Error Response", error.response.data);
                console.log("Error Status", error.response.status);
                console.log("Error Headers", error.response.headers);

                if (error.response.status === 400) {
                  swal({
                    title: "Error 400",
                    text: error.response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                } else if (error.response.status === 401) {
                  swal({
                    title: "Error 401",
                    text: error.response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                } else {
                  swal({
                    title: "Error",
                    text: `Código de error: ${error.response.status}`,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              } else if (error.request) {
                // La solicitud se hizo pero no se recibió respuesta
                console.log("Error Request", error.request);
                swal({
                  title: "Error",
                  text: "No se recibió respuesta del servidor.",
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              } else {
                // Algo pasó al configurar la solicitud que desencadenó un error
                console.log("Error Message", error.message);
                swal({
                  title: "Error",
                  text: `Error en la configuración de la solicitud: ${error.message}`,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            });
        }
      }
    },
    getConfigTpv(numConfig) {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: numConfig,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (numConfig == 98) {
              vm.config98 = response.data.result;
            } else if (numConfig == 99) {
              vm.config99 = response.data.result;
            } else if (numConfig == 101) {
              vm.config101 = response.data.result;
            }
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ConfirmacionExport() {
      if (!this.configTpv) {
        swal({
          type: "error",
          title: "No tienes permisos para exportar los datos a Gstock",
          //text: 'Something went wrong!',
        });
      } else {
        swal({
          title: this.$t("estasSeguroDeExportarLasVentas"),
          text:
            this.$t("ventasExportadas") +
            " (" +
            moment(String(this.datefrom)).format("DD/MM/YYYY") +
            " " +
            moment(String(this.dateto)).format("DD/MM/YYYY") +
            ")",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-info btn-fill",
          cancelButtonClass: "btn btn-info btn-fill",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
        }).then((result) => {
          if (result.value) {
            this.exportGStock();
          }
        });
      }
    },

    getProductos() {
  // Si hay parámetro de búsqueda en la ruta, úsalo
  const query = this.$route.params.query || this.searchProductosQuery || "";

  // Decide el controlador según si hay búsqueda
  const controller = query
    ? "gstock/searchProductsByBusiness/" + encodeURIComponent(query)
    : "gstock/getProductsGstock";

  var config = {
    params: {
      idBusiness: this.idBusiness,
      idTpv: 0,
      pag: this.pag,
      idCategoria: this.idCategoria,
      jwt: this.$store.getters.jwt,
    },
    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
  };

  let vm = this;
  this.axios
    .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
    .then(function (response) {
      if (response.data.response) {
        vm.list = response.data.result.elementos;
        vm.pag = response.data.result.pag;
        vm.totalPags = response.data.result.totalPags;
        vm.getCategorias();
      } else {
        vm.loadingGeneral && vm.loadingGeneral.close();
        swal({
          title: vm.$t("atencion"),
          text: response.data.message,
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
},
    changedPLU(obj, tipo) {
      if (tipo == 0) {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            rate: obj.rate,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      } else {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
      }

      var params = {
        idBusiness: this.idBusiness,
        idProduct: obj.id,
        newPLU: obj.newPLU,
        tipo: tipo,
        jwt: this.$store.getters.jwt,
      };
      // console.log(params);
      let vm = this;
      let controller = "gstock/updatePLU";
      this.axios
        .post(
          this.$store.getters.apiUrl + "integracion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            let notify = vm.$t("actualizado");
            vm.$notify({
              message:
                vm.$t("coste") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            obj.PLU = obj.newPLU;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCategorias() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "integracion/gstock/getCategorias",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategorias = response.data.result;
            //   console.log(vm.totalPags);
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getSubproducts() {
      const controller = this.searchQuery
        ? "gstock/searchSubproductsByBusiness/" + this.searchQuery
        : "gstock/getSubproductsByBusinessGStock";
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          idTag: this.idTag,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result.elementos;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;

            vm.respuesta = true;

            vm.getTags();
          } else {
            vm.loadingGeneral.close();
            swal({
              title: this.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTags() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listTags = response.data.result;
            //   console.log(vm.totalPags);
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleTabChange(tabIndex, newTab, oldTab) {
      this.pag = 1;
      this.searchQuery = "";
      this.n = 0;
      // console.log(newTab)
      if (this.tabs == "Materias Primas") {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        this.getSubproducts();
        this.loadingGeneral.close();
      } else if (this.tabs == "Productos") {
        // this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        this.getProductos();
      }
    },

    searchSubproductos() {
      if (this.searchQuery !== undefined && this.searchQuery !== "") {
        this.$router.push({
          name: "search-prducto-gs",
          params: { query: this.searchQuery },
        });
        //this.isSearch = true;
      }
    },
    removeSearchSubPRoduct() {
      if (this.searchQuery && this.searchQuery !== "") {
        this.searchQuery = "";
        //  this.isSearch = false;
        this.$router.push({ name: "gstock", params: { pag: 1 } });
        this.getSubproducts();
      }
    },
    searchProductos() {
  const query = this.searchProductosQuery.trim();

  if (!query) {
    console.log("searchProductos: Query vacío");
    return;
  }

  this.$router.push({
    name: "search-prducto-gs",
    params: { query },
    query: {
      pag: this.pag || 1,
      idBusiness: this.idBusiness,
      idTag: this.idTag || 0,
      jwt: this.$store.getters.jwt
    }
  });
},

  buscarProductos(query) {
  const params = {
    pag: this.pag || 1,
    idBusiness: this.idBusiness,
    idTag: this.idTag || 0,
    jwt: this.$store.getters.jwt
  };

  this.axios
    .get(
      this.$store.getters.apiUrl + 
      `gstock/searchProductsByBusiness/${encodeURIComponent(query)}`, 
      { params }
    )
    .then(response => {
      this.resultados = response.data;
      // actualizar UI aquí
    })
    .catch(error => {
      console.error("Error al buscar productos:", error);
    });
},


    removeSearchProduct() {
  this.searchProductosQuery = ""; // Limpia el input de búsqueda
  this.$router.push({ name: "gstock", params: { pag: 1 } }); // Navega a la ruta sin query
  this.getProductos(); // Vuelve a cargar todos los productos
},

    replicarProductosTpvs() {
      console.log("Método replicarProductosTpvs llamado");
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
              "integracion/gstock/replicarProductosTpvs",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            const data = response.data;
            const resumen = data.resumen || {};
            const actualizados = resumen.productosActualizados || 0;
            const errores = resumen.productosConErrores || 0;

            const mensajeResumen =
              `<div style="text-align: left;">` +
              `✅ <strong>${vm.$t("actualizados")}:</strong> ${actualizados}<br>` +
              `❌ <strong>${vm.$t("conErrores")}:</strong> ${errores}` +
              `</div>`;

            if (actualizados === 0) {
              swal({
                title: vm.$t("atencion"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-warning btn-fill",
                icon: "warning",
              });
            } else {
              swal({
                title: vm.$t("pluReplicadosExitosamente"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-success btn-fill",
                icon: "success",
              });
            }
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.error("Error:", error);

            let msg = vm.$t("errorDesconocido");
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              msg = error.response.data.message;
            }

            swal({
              title: vm.$t("atencion"),
              text: msg,
              confirmButtonClass: "btn btn-info btn-fill",
              icon: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          icon: "error",
        });
      }
    },

    replicarMateriasPrimasTpvs() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
              "integracion/gstock/replicarMateriasPrimasTpvs",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            const data = response.data;
            const resumen = data.resumen || {};

            const actualizados = resumen.subproductosActualizados || 0;
            const errores = resumen.subproductosConErrores || 0;

            const mensajeResumen =
              `<div style="text-align: left;">` +
              `✅ <strong>${vm.$t("actualizados")}:</strong> ${actualizados}<br>` +
              `❌ <strong>${vm.$t("conErrores")}:</strong> ${errores}` +
              `</div>`;

            if (actualizados === 0) {
              swal({
                title: vm.$t("atencion"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-warning btn-fill",
                icon: "warning",
              });
            } else {
              swal({
                title: vm.$t("pluReplicadosExitosamente"),
                html: mensajeResumen,
                confirmButtonClass: "btn btn-success btn-fill",
                icon: "success",
              });
            }
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.error("Error:", error);

            let msg = vm.$t("errorDesconocido");
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              msg = error.response.data.message;
            }

            swal({
              title: vm.$t("atencion"),
              text: msg,
              confirmButtonClass: "btn btn-info btn-fill",
              icon: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          icon: "error",
        });
      }
    },


    replicarPLUsProductosBusiness() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness,
          idsBusinesses: this.selectedBusinessCompany,
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl +
              "integracion/gstock/replicarProductosPLUsBusiness",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            // Datos de respuesta
            let data = response.data;

            // Construir resumen de nombres duplicados si existen
            let duplicados = data.productosConNombresDuplicadosEnOrigen || [];

            let mensajeDuplicados = "";
            if (duplicados.length > 0) {
              mensajeDuplicados =
                "<ul style='padding-left: 20px;'>" +
                duplicados
                  .map(function (d) {
                    return `<li><strong>${d.name}</strong> ${vm.$t('seRepite')} ${d.ids.length} veces.</li>`;
                  })
                  .join("") +
                "</ul>";
            }

            // Mensaje principal, todo alineado a la izquierda
            let mensajeResumen =
              `<div style="text-align: left;">` +
              `<p>✅ <strong>${data.productosActualizados || 0}</strong> ${vm.$t('productosActualizadosResumen')}<br>` +
              `🔍 <strong>${data.productosNoEncontrados || 0}</strong> ${vm.$t('productosNoEncontradosResumen')}<br>` +
              `ℹ️ <strong>${data.productosSinCambios || 0}</strong> ${vm.$t('productosSinCambiosResumen')}</p>` +
              (duplicados.length > 0
                ? `<p><strong>${vm.$t("advertenciaPLUsDuplicadosProductos")}</strong></p>${mensajeDuplicados}`
                : "") +
              `</div>`;

            // Mostrar swal SIEMPRE con el resumen
            swal({
              title: data.success
                ? vm.$t("pluReplicadosExitosamente")
                : vm.$t("atencion"),
              html: mensajeResumen,
              confirmButtonClass: "btn btn-info btn-fill",
              type: data.success ? "success" : "error",
            });
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.log("Error:", error);
            let errorMessage = vm.$t("errorDesconocido");
            if (error.response) {
              errorMessage = error.response.data.message || errorMessage;
            }
            swal({
              title: vm.$t("atencion"),
              text: errorMessage,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    replicarPLUSubProductosBusiness() {
      if (this.listTpv.length > 0) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        const params = {
          idBusiness: this.idBusiness, // origen
          idsBusinesses: this.selectedBusinessCompanySubproducts, // destinos
          jwt: this.$store.getters.jwt,
        };

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt,
          },
        };

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl +
              "integracion/gstock/replicarSubProductsPLUBusiness",
            params,
            config
          )
          .then(function (response) {
            vm.loadingGeneral.close();

            let data = response.data;

            let duplicados = data.subproductosConNombresDuplicadosEnOrigen || [];

            let mensajeDuplicados = "";
            if (duplicados.length > 0) {
              mensajeDuplicados =
                "<ul style='padding-left: 20px;'>" +
                duplicados
                  .map(function (d) {
                    return `<li><strong>${d.name}</strong> ${vm.$t('seRepite')} ${d.ids.length} veces.</li>`;
                  })
                  .join("") +
                "</ul>";
            }

            let mensajeResumen =
            `<div style="text-align: left;">` +
            `<p>✅ <strong>${data.subproductosActualizados || 0}</strong> ${vm.$t('subproductosActualizadosResumen')}<br>` +
            `🔍 <strong>${data.subproductosNoEncontrados || 0}</strong> ${vm.$t('subproductosNoEncontradosResumen')}<br>` +
            `ℹ️ <strong>${data.subproductosSinCambios || 0}</strong> ${vm.$t('subproductosSinCambiosResumen')}<br>` +
            (duplicados.length > 0
              ? `<p><strong>${vm.$t("advertenciaPLUsDuplicadosSubproductos")}</strong></p>${mensajeDuplicados}`
              : "") +
            `</div>`;

            swal({
              title: data.success
                ? vm.$t("pluReplicadosExitosamente")
                : vm.$t("atencion"),
              html: mensajeResumen,
              confirmButtonClass: "btn btn-info btn-fill",
              type: data.success ? "success" : "error",
            });
          })
          .catch(function (error) {
            vm.loadingGeneral.close();
            console.log("Error:", error);
            let errorMessage = vm.$t("errorDesconocido");
            if (error.response) {
              errorMessage = error.response.data.message || errorMessage;
            }
            swal({
              title: vm.$t("atencion"),
              text: errorMessage,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("debeSeleccionarUnTpv"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    handleBusinessesCompanyUpdated(businesses) {
      this.listBusinessesCompany = businesses;

      // Reset de seleccionadores de productos
      this.selectedBusinessCompany = [];
      this.selectAll = false;

      // Reset de seleccionadores de subproductos
      this.selectedBusinessCompanySubproducts = [];
      this.selectAllSubproducts = false;

      console.log(
        "listBusinessesCompany actualizada:",
        this.listBusinessesCompany
      );
    },
    handleSelectChange(newValue) {
      console.log("Selección cambiada a:", newValue);
      const addedIds = newValue.filter(
        (id) => !this.selectedBusinessCompany.includes(id)
      );
      const removedIds = this.selectedBusinessCompany.filter(
        (id) => !newValue.includes(id)
      );
      if (addedIds.length) console.log("IDs seleccionados:", addedIds);
      if (removedIds.length) console.log("IDs deseleccionados:", removedIds);
      this.selectedBusinessCompany = [...newValue]; // Sincroniza el array
      this.selectAll =
        this.listBusinessesCompany.length > 0 &&
        this.selectedBusinessCompany.length ===
          this.listBusinessesCompany.length;
      console.log("selectedBusinessCompany actual:", [
        ...this.selectedBusinessCompany,
      ]);
    },
    handleCheckboxChange(businessId, checked) {
      const selected = [...this.selectedBusinessCompany];
      const index = selected.indexOf(businessId);

      if (checked && index === -1) {
        selected.push(businessId);
      } else if (!checked && index !== -1) {
        selected.splice(index, 1);
      }

      this.selectedBusinessCompany = selected;
      this.selectAll =
        this.listBusinessesCompany.length > 0 &&
        this.selectedBusinessCompany.length === this.listBusinessesCompany.length;
    },
       toggleSelectAll(checked) {
        console.log("toggleSelectAll llamado con checked:", checked);
        if (checked) {
          this.selectedBusinessCompany = this.listBusinessesCompany.map(b => b.id);
        } else {
          this.selectedBusinessCompany = [];
        }
      },



    isBusinessSelected(businessId) {
      return this.selectedBusinessCompany.includes(businessId);
    },

    toggleBusinessSubproduct(businessId) {
      const selected = this.selectedBusinessCompanySubproducts;
      const index = selected.indexOf(businessId);

      if (index === -1) {
        selected.push(businessId);
      } else {
        selected.splice(index, 1);
      }

      this.selectAllSubproducts =
        this.listBusinessesCompany.length > 0 &&
        selected.length === this.listBusinessesCompany.length;
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200); // Pequeño delay para permitir clics en el dropdown
    },

      toggleSelectAllSubproducts(checked) {
      if (checked) {
        this.selectedBusinessCompanySubproducts = this.listBusinessesCompany.map(b => b.id);
      } else {
        this.selectedBusinessCompanySubproducts = [];
      }
    },

    handleCheckboxChangeSubproducts(businessId, checked) {
      let updated = [...this.selectedBusinessCompanySubproducts];
      if (checked) {
        if (!updated.includes(businessId)) updated.push(businessId);
      } else {
        updated = updated.filter((id) => id !== businessId);
      }
      this.selectedBusinessCompanySubproducts = updated;
      this.selectAllSubproducts =
        this.listBusinessesCompany.length > 0 &&
        updated.length === this.listBusinessesCompany.length;
    },

    toggleBusiness(businessId) {
      const index = this.selectedBusinessCompany.indexOf(businessId);
      if (index === -1) {
        this.selectedBusinessCompany.push(businessId);
      } else {
        this.selectedBusinessCompany.splice(index, 1);
      }

      this.selectAll =
        this.listBusinessesCompany.length > 0 &&
        this.selectedBusinessCompany.length === this.listBusinessesCompany.length;
    },

    confirmarReplicacionProductos() {
      swal({
        title: this.$t("estasSeguro"),
        text: this.$t("conEstaAccionPLUTpvs"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarProductosTpvs();
        }
      });
    },

    confirmarReplicacionProductosPLUBusiness() {
      swal.fire({
        title: this.$t("estasSeguro"),
        html: `
          <p>${this.$t("conEstaAcciónPLU")}</p>
          <p style="margin-top: 10px; text-align: left;">
            ⚠️ <strong>${this.$t("advertenciaPLUTexto1Prod")}</strong><br>
            ${this.$t("advertenciaPLUTexto2Prod")}
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarPLUsProductosBusiness();
          this.closeModal();
        }
      });
    },

    confirmarReplicacionSubproductos() {
      swal.fire({
        title: this.$t("estasSeguro"),
        text: this.$t("conEstaAccionPLUTpvs"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
         if (result.isConfirmed || result.value) {
          this.replicarMateriasPrimasTpvs();
        }
      });
    },

    confirmarReplicacionSubProductosPLUBusiness() {
      swal.fire({
        title: this.$t("estasSeguro"),
        html: `
          <p>${this.$t("conEstaAcciónPLUSubProductos")}</p>
          <p style="margin-top: 10px; text-align: left;">
            ⚠️ <strong>${this.$t("advertenciaSubPLUTexto1")}</strong><br>
            ${this.$t("advertenciaSubPLUTexto2")}
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
        showCloseButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.value) {
          this.replicarPLUSubProductosBusiness();
          this.closeModalSubproducts();
        }
      });
    },

    closeModal() {
      this.$modal.hide("modalSeleccionBusiness");
    },

    closeModalSubproducts() {
      this.$modal.hide("modalSeleccionBusinessSubproducts");
    },

    checkIfAllSelected() {
      this.selectAll = this.selectedBusinessCompanySubproducts.length === this.listBusinessesCompany.length;
    },

    toggleSelectAllProducts(checked) {
    if (checked) {
      this.selectedBusinessCompany = this.listBusinessesCompany.map(b => b.id);
    } else {
      this.selectedBusinessCompany = [];
    }
  },

     checkIfAllSelectedProducts() {
      this.selectAllProducts = this.selectedBusinessCompany.length === this.listBusinessesCompany.length;
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

/* Oculta completamente los tags */
.el-select.no-display-tags >>> .el-select__tags {
  display: none !important;
}

/* Oculta el contenido del input pero deja el placeholder */
.el-select.no-display-tags >>> .el-input__inner {
  color: transparent !important;
  caret-color: transparent !important;
  text-indent: -9999px; /* asegura que no se vea nada textual */
}

/* Mantiene el placeholder visible */
.el-select.no-display-tags >>> .el-input__inner::placeholder {
  color: #999 !important;
  text-indent: 0px !important; /* resetea solo para placeholder */
}

/* Oculta el check azul que aparece en el texto seleccionado */
.el-select-dropdown__item.selected:not(.is-disabled) {
  background-color: transparent !important;
  color: inherit !important;
}

/* Evita el cambio de cursor en el texto y evita el foco visual */
.el-option__content {
  cursor: default;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Evita que el checkbox del el-select por defecto aparezca */
.el-select .el-input__inner {
  user-select: none;
}

/* Opcional: para que no se vea el tag de selección */
.no-display-tags .el-select__tags {
  display: none !important;
}

.btn-disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.el-select-dropdown__item.selected::after {
  display: none !important;
}

.btn {
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: bold;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.btn-primary:hover {
  background-color: #0069d9;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/G-Stock/G-Stock.vue